import React, { useEffect } from 'react';
import { postData } from '../Utils/apiService';

const VisitorCount = () => {
  useEffect(() => {
    const incrementCount = async () => {
      try {
        // Check if this session has already been counted
        const hasBeenCounted = sessionStorage.getItem('visitorCounted');
        
        if (!hasBeenCounted) {
          // If not counted yet, increment the count
          await postData('/settings/count');
          // Mark this session as counted
          sessionStorage.setItem('visitorCounted', 'true');
        }
      } catch (error) {
        console.error('Failed to increment visitor count:', error);
      }
    };

    // Call the function when component mounts
    incrementCount();
  }, []);

  // Return null since we don't want to render anything
  return null;
};

export default VisitorCount; 